const services = [
  {
    icon: 'ri-robot-2-line',
    title: 'AI Voice Agents',
    description: 'Intelligent voice assistants that answer calls, qualify leads, and book appointments automatically 24/7.'
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Smart Calendars',
    description: 'Automated scheduling system that syncs with your team and eliminates double bookings instantly.'
  },
  {
    icon: 'ri-layout-line',
    title: 'Website Design',
    description: 'Modern, conversion-optimized websites built to capture leads and showcase your services professionally.'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Lead Capture Systems',
    description: 'Multi-channel lead generation tools that capture every opportunity from calls, forms, and chat.'
  },
  {
    icon: 'ri-mail-send-line',
    title: 'Automated Follow-Up',
    description: 'Smart follow-up sequences that nurture leads and convert prospects without manual effort.'
  },
  {
    icon: 'ri-database-2-line',
    title: 'CRM Automation',
    description: 'Centralized client communication hub that keeps your team organized and customers engaged.'
  }
];

export default function Services() {
  return (
    <section className="relative py-32 bg-gradient-to-b from-black via-[#0a0e27] to-black overflow-hidden">
      {/* Top Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-cyan-500/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20 scroll-reveal">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-400/10 border border-cyan-400/30 backdrop-blur-sm mb-6">
            <span className="text-xs font-bold text-cyan-400 tracking-wider uppercase">Our Solutions</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            AI-Powered Services for<br />Home Service Businesses
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group scroll-reveal bg-white/[0.03] backdrop-blur-xl border border-cyan-400/20 rounded-2xl p-8 transition-all duration-500 hover:bg-white/[0.08] hover:border-cyan-400/50 hover:-translate-y-2 hover:shadow-[0_0_60px_rgba(0,212,255,0.3)] cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-6 bg-gradient-to-br from-cyan-400/20 to-blue-600/20 rounded-2xl border border-cyan-400/30 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500">
                <i className={`${service.icon} text-3xl text-cyan-400 drop-shadow-[0_0_10px_rgba(0,212,255,0.8)]`} />
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {service.description}
              </p>

              {/* Hover Glow Effect */}
              <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}